import { ref } from '@vue/composition-api'
import store from '@/store'
import { parseRequestError } from '@/helpers/helpers'

export default (props, { root }) => {
  const route = root.$route
  const { paymentId } = route.params

  const paymentStatus = ref(null)
  const progressValue = ref(100)
  const longerThan30s = ref(false)
  const interval = ref(null)

  const transformStatus = s => {
    switch (s) {
      case 'completed':
        return true
      default:
        return null
    }
  }

  let fetching = false
  const fetchStatus = () => {
    if (!fetching) {
      fetching = true
      store.dispatch('customers/fetchPaymentStatus', paymentId)
        .then(data => {
          paymentStatus.value = transformStatus(data.status)
          if (paymentStatus.value) {
            clearInterval(interval.value)
          }
        })
        .catch(err => parseRequestError(err))
        .finally(() => {
          fetching = false
        })
    }
  }

  fetchStatus()
  interval.value = setInterval(() => {
    fetchStatus()
  }, 3000)

  setTimeout(() => {
    progressValue.value = 0
  }, 100)

  setTimeout(() => {
    longerThan30s.value = true
  }, 30000)

  return {
    paymentId,
    progressValue,
    paymentStatus,
    longerThan30s,
    interval,
  }
}
